<template>
    <div class="my-account-wrapper">
        <div class="row">
            <div class="col-12">
                <div class="page__head-title page__head-title--orange">
                    <div class="page__head-title__text page__head-title__text--orange">Pièces justificatives requises</div>
                </div>
            </div>
            <!-- Conditions Particulières signées [SIGNED MEMBERSHIP] -->
            <div class="col-12">
                <div class="form_ttl_first">Conditions Particulières signées :</div>
            </div>
            <div class="col-3">
              <div class="col-12">
                <div class="icon-signed-membership my-document"></div>
              </div>
              <div class="col-12">
                <label class="custom-filter__inputs--label">
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="signedMembership.submitted"  @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Soumis</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="signedMembership.approved" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Approuvé</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="signedMembership.declined" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Refusé</span>
                    </label>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-9">
              <div class="col-12 main-info">Veuillez soumettre les conditions particulières signées.</div>
              <div class="col-12">
                <button class="custom-filter__buttons--button" @click="reviewDocs('signedMembership')">{{signedMembershipButtonLabel}}</button>
              </div>
            </div>

            <!-- Carte-grise [GRAY CARD] -->
          <template v-if="!isMutuaide">
            <div class="col-12">
              <div class="form_ttl_first">Carte-grise :</div>
            </div>
            <div class="col-3">
              <div class="col-12">
                <div class="icon-gray-card my-document"></div>
              </div>
              <div class="col-12">
                <label class="custom-filter__inputs--label">
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="grayCard.submitted"  @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Soumis</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="grayCard.approved" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Approuvé</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="grayCard.declined" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Refusé</span>
                    </label>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-9">
              <div class="col-12 main-info">Veuillez soumettre la carte grise du camping-car.</div>
              <div class="col-12">
                <button class="custom-filter__buttons--button" @click="reviewDocs('grayCard')">{{grayCardButtonLabel}}</button>
              </div>
            </div>
          </template>

            <!-- Permis de conduire [DRIVER'S LICENSE] -->
          <template v-if="!isMutuaide">
            <div class="col-12">
              <div class="form_ttl_first">Permis de conduire :</div>
            </div>
            <div class="col-3">
              <div class="col-12">
                <div class="icon-name-and-contact my-document"></div>
              </div>
              <div class="col-12">
                <label class="custom-filter__inputs--label">
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="driverLicense.submitted"  @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Soumis</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="driverLicense.approved" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Approuvé</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="driverLicense.declined" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Refusé</span>
                    </label>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-9">
              <div class="col-12 main-info">Veuillez soumettre le permis de conduite du propriétaire du camping-car.</div>
              <div class="col-12">
                <button class="custom-filter__buttons--button" @click="reviewDocs('driverLicense')">{{driverLicenseButtonLabel}}</button>
              </div>
            </div>
          </template>

            <!-- Relevé d’information < 3 mois [Informations report] -->
          <template v-if="!isMutuaide">
            <div class="col-12">
              <div class="form_ttl_first">Relevé d’information < 3 mois :</div>
            </div>
            <div class="col-3">
              <div class="col-12">
                <div class="icon-information-report my-document"></div>
              </div>
              <div class="col-12">
                <label class="custom-filter__inputs--label">
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="informationReport.submitted"  @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Soumis</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="informationReport.approved" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Approuvé</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="informationReport.declined" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Refusé</span>
                    </label>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-9">
                <div class="col-12 main-info">Veuillez soumettre le relevé d’informations du propriétaire du camping-car < 3 mois.</div>
                <div class="col-12">
                  <button class="custom-filter__buttons--button" @click="reviewDocs('informationReport')">{{informationReportButtonLabel}}</button>
                </div>
            </div>
          </template>

            <!-- Relevé d’Identité Bancaire [Bank details] -->
          <template v-if="!isMutuaide">
            <div class="col-12">
                <div class="form_ttl_first">Relevé d’Identité Bancaire :</div>
            </div>
            <div class="col-3">
                <div class="col-12">
                    <div class="icon-bank-details my-document"></div>
                </div>
                <div class="col-12">
                    <label class="custom-filter__inputs--label">
                        <div class="checkboxes-wrap--item">
                            <label class="checkboxes__element">
                                <input type="checkbox" class="checkboxes__element--input"
                                       v-model="bankDetails.submitted"  @click.prevent="onClick"/>
                                <span class="checkboxes__element--text">Soumis</span>
                            </label>
                        </div>
                        <div class="checkboxes-wrap--item">
                            <label class="checkboxes__element">
                                <input type="checkbox" class="checkboxes__element--input"
                                       v-model="bankDetails.approved" @click.prevent="onClick"/>
                                <span class="checkboxes__element--text">Approuvé</span>
                            </label>
                        </div>
                        <div class="checkboxes-wrap--item">
                          <label class="checkboxes__element">
                            <input type="checkbox" class="checkboxes__element--input"
                                   v-model="bankDetails.declined" @click.prevent="onClick"/>
                            <span class="checkboxes__element--text">Refusé</span>
                          </label>
                        </div>
                    </label>
                </div>
            </div>

            <div class="col-9">
                <div class="col-12 main-info">Veuillez soumettre le relevé d’identité bancaire du propriétaire du camping-car.</div>
                <div class="col-12">
                    <button class="custom-filter__buttons--button" @click="reviewDocs('bankDetails')">{{bankDetailsButtonLabel}}</button>
                </div>
            </div>
          </template>


            <!-- Factures d’entretien [Maintenance invoices] -->
          <template v-if="!isMutuaide">
            <div class="col-12">
                <div class="form_ttl_first">Factures d’entretien :</div>
            </div>
            <div class="col-3">
                <div class="col-12">
                    <div class="icon-signed-membership my-document"></div>
                </div>
                <div class="col-12">
                    <label class="custom-filter__inputs--label">
                        <div class="checkboxes-wrap--item">
                            <label class="checkboxes__element">
                                <input type="checkbox" class="checkboxes__element--input"
                                       v-model="maintenanceInvoices.submitted"  @click.prevent="onClick"/>
                                <span class="checkboxes__element--text">Soumis</span>
                            </label>
                        </div>
                        <div class="checkboxes-wrap--item">
                            <label class="checkboxes__element">
                                <input type="checkbox" class="checkboxes__element--input"
                                       v-model="maintenanceInvoices.approved" @click.prevent="onClick"/>
                                <span class="checkboxes__element--text">Approuvé</span>
                            </label>
                        </div>
                      <div class="checkboxes-wrap--item">
                        <label class="checkboxes__element">
                          <input type="checkbox" class="checkboxes__element--input"
                                 v-model="maintenanceInvoices.declined" @click.prevent="onClick"/>
                          <span class="checkboxes__element--text">Refusé</span>
                        </label>
                      </div>
                    </label>
                </div>
            </div>

            <div class="col-9">
                <div class="col-12 main-info">Veuillez soumettre les factures d’entretien.</div>
                <div class="col-12">
                    <button class="custom-filter__buttons--button" @click="reviewDocs('maintenanceInvoices')">{{maintenanceInvoicesButtonLabel}}</button>
                </div>
            </div>
          </template>

          <!-- KBIS [KBIS] -->
          <template v-if="isMutuaide">
            <div class="col-12">
              <div class="form_ttl_first">Kbis :</div>
            </div>
            <div class="col-3">
              <div class="col-12">
                <div class="icon-bank-details my-document"></div>
              </div>
              <div class="col-12">
                <label class="custom-filter__inputs--label">
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="kbis.submitted"  @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Soumis</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="kbis.approved" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Approuvé</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="kbis.declined" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Refusé</span>
                    </label>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-9">
              <div class="col-12 main-info">Veuillez soumettre le Kbis du client.</div>
              <div class="col-12">
                <button class="custom-filter__buttons--button" @click="reviewDocs('kbis')">{{kbisButtonLabel}}</button>
              </div>
            </div>
          </template>

          <!-- Pièces d'identité du dirigeant [OWNER'S ID] -->
          <template v-if="isMutuaide">
            <div class="col-12">
              <div class="form_ttl_first">Pièces d'identité du dirigeant :</div>
            </div>
            <div class="col-3">
              <div class="col-12">
                <div class="icon-name-and-contact my-document"></div>
              </div>
              <div class="col-12">
                <label class="custom-filter__inputs--label">
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="ownerID.submitted"  @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Soumis</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="ownerID.approved" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Approuvé</span>
                    </label>
                  </div>
                  <div class="checkboxes-wrap--item">
                    <label class="checkboxes__element">
                      <input type="checkbox" class="checkboxes__element--input"
                             v-model="ownerID.declined" @click.prevent="onClick"/>
                      <span class="checkboxes__element--text">Refusé</span>
                    </label>
                  </div>
                </label>
              </div>
            </div>

            <div class="col-9">
              <div class="col-12 main-info">Veuillez soumettre les pièces d'identité du dirigeant.</div>
              <div class="col-12">
                <button class="custom-filter__buttons--button" @click="reviewDocs('ownerid')">{{ownerIDButtonLabel}}</button>
              </div>
            </div>
          </template>
        </div>
    </div>

</template>

<script>

    import {validationMixin} from 'vuelidate'
    import {required, email} from 'vuelidate/lib/validators'
    import Multiselect from 'vue-multiselect'

    export default {
        name: 'ClientDocuments',
        data() {
            return {
                signedMembership: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                signedMembershipButtonLabel: 'Commencer',
                grayCard: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                grayCardButtonLabel: 'Commencer',
                driverLicense: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                driverLicenseButtonLabel: 'Commencer',
                informationReport: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                informationReportButtonLabel: 'Commencer',
                bankDetails: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                bankDetailsButtonLabel: 'Commencer',
                maintenanceInvoices: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                maintenanceInvoicesButtonLabel: 'Commencer',
                kbis: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                kbisButtonLabel: 'Commencer',
                ownerID: {
                  submitted: false,
                  approved: false,
                  canceled: false,
                  declined: false,
                  pending: false
                },
                ownerIDButtonLabel: 'Commencer',
                verification_documents: []
            }
        },
        components: {Multiselect},
        mixins: [
            validationMixin
        ],
        computed: {
            user() {
                return this.$store.state.userInfo;
            },
            clientId() {
                return this.$route.params.id;
            },
            isMutuaide() {
              return this.$store.getters.isMutuaide;
            }
        },
        watch: {
            '$store.getters.getAuthUserInfo': function(user) {}
        },
        methods: {
          parseDate(garanty) {
            if (garanty && garanty.created_at) {
              let day = garanty.datesParse.day_created,
                month = garanty.datesParse.month_created,
                year = garanty.datesParse.year_created;
              return day + "/" + month + '/' + year;
            }

            return ' - ';
          },
            reviewDocs(type) {
              let url = 'clients';
              switch (type) {
                case 'signedMembership':
                    url = '/signed-membership-import';
                  break;
                case 'grayCard':
                    url = '/gray-card-import';
                  break;
                case 'driverLicense':
                    url = '/driver-license-import';
                  break;
                case 'informationReport':
                    url = '/information-report-import';
                  break;
                case 'bankDetails':
                    url = '/bank-details';
                    break;
                case 'maintenanceInvoices':
                    url = '/maintenance-invoices';
                  break;
                case 'kbis':
                  url = '/kbis';
                  break;
                case 'ownerid':
                  url = '/owner-id';
                  break;
              }
                // console.log(`reviewDocs : ${type} | url -> ${url} | ID -> ${this.$route.params.id}`);
                this.$router.push(`${url}/${this.clientId}`);
            },
            parseDocuments(documents) {
              let signedMembershipCanceled = false;
              let grayCardCanceled = false;
              let driverLicenseCanceled = false;
              let informationReportCanceled = false;
              let bankDetailsCanceled = false;
              let maintenanceInvoicesCanceled = false;
              let kbisCanceled = false;
              let ownerIDCanceled = false;
              if (documents.length > 0) {
                for ( let i in documents) {
                  let doc = documents[i];
                  if (doc.type_name === 'signed_membership') {
                    if (doc.status !== 'approved' && !signedMembershipCanceled) {
                        signedMembershipCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.signedMembership.submitted = true;
                      this.signedMembershipButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.signedMembership.approved = this.signedMembership.submitted = true;
                      this.signedMembershipButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.signedMembership.declined = true;
                    }
                    if (doc.status === 'pending'){
                      this.signedMembership.pending = true;
                      this.signedMembershipButtonLabel = 'Changer';
                    }
                  }
                  if (doc.type_name === 'gray_card') {
                    if (doc.status !== 'approved' && !grayCardCanceled) {
                        grayCardCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.grayCard.submitted = true;
                      this.grayCardButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.grayCard.approved = this.grayCard.submitted = true;
                      this.grayCardButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.grayCard.declined = true;
                    }
                    if (doc.status === 'pending'){
                      this.grayCard.pending = true;
                      this.grayCardButtonLabel = 'Changer';
                    }
                  }
                  if (doc.type_name === 'driver_license') {
                    if (doc.status !== 'approved' && !driverLicenseCanceled) {
                        driverLicenseCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.driverLicense.submitted = true;
                      this.driverLicenseButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.driverLicense.approved = this.driverLicense.submitted = true;
                      this.driverLicenseButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.driverLicense.declined = true;
                    }
                    if (doc.status === 'pending'){
                      this.driverLicense.pending = true;
                      this.driverLicenseButtonLabel = 'Changer';
                    }
                  }
                  if (doc.type_name === 'information_report') {
                    if (doc.status !== 'approved' && !informationReportCanceled) {
                        informationReportCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.informationReport.submitted = true;
                      this.informationReportButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.informationReport.approved = this.informationReport.submitted = true;
                      this.informationReportButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.informationReport.declined = true;
                    }
                    if (doc.status === 'pending'){
                      this.informationReport.pending = true;
                      this.informationReportButtonLabel = 'Changer';
                    }
                  }
                  if (doc.type_name === 'bank_details') {
                    if (doc.status !== 'approved' && !bankDetailsCanceled) {
                        bankDetailsCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.bankDetails.submitted = true;
                      this.bankDetailsButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.bankDetails.approved = this.bankDetails.submitted = true;
                      this.bankDetailsButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.bankDetails.declined = true;
                    }
                    if (doc.status === 'pending'){
                      this.bankDetails.pending = true;
                      this.bankDetailsButtonLabel = 'Changer';
                    }
                  }
                  if (doc.type_name === 'maintenance_invoices') {
                    if (doc.status !== 'approved' && !maintenanceInvoicesCanceled) {
                        maintenanceInvoicesCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.maintenanceInvoices.submitted = true;
                      this.maintenanceInvoicesButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.maintenanceInvoices.approved = this.maintenanceInvoices.submitted = true;
                      this.maintenanceInvoicesButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.maintenanceInvoices.declined = true;
                    }
                    if (doc.status === 'pending'){
                      this.maintenanceInvoices.pending = true;
                      this.maintenanceInvoicesButtonLabel = 'Changer';
                    }
                  }
                  if (doc.type_name === 'kbis') {
                    if (doc.status !== 'approved' && !kbisCanceled) {
                      kbisCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.kbis.submitted = true;
                      this.kbisButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.kbis.approved = this.kbis.submitted = true;
                      this.kbisButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.kbis.declined = true;
                    }
                  }
                  if (doc.type_name === 'ownerid') {
                    if (doc.status !== 'approved' && !ownerIDCanceled) {
                      ownerIDCanceled = true;
                    }
                    if (doc.status === 'submitted') {
                      this.ownerID.submitted = true;
                      this.ownerIDButtonLabel = 'Changer';
                    }
                    if (doc.status === 'approved') {
                      this.ownerID.approved = this.ownerID.submitted = true;
                      this.ownerIDButtonLabel = 'Visualiser';
                    }
                    if (doc.status === 'declined') {
                      this.ownerID.declined = true;
                    }
                  }
                }
                if (signedMembershipCanceled) {
                    this.signedMembership.approved = false;
                }
                if (grayCardCanceled) {
                    this.grayCard.approved = false;
                }
                if (driverLicenseCanceled) {
                    this.driverLicense.approved = false;
                }
                if (informationReportCanceled) {
                    this.informationReport.approved = false;
                }
                if (bankDetailsCanceled) {
                    this.bankDetails.approved = false;
                }
                if (maintenanceInvoicesCanceled) {
                    this.maintenanceInvoices.approved = false;
                }
                if (kbisCanceled) {
                  this.kbis.approved = false;
                }
                if (ownerIDCanceled) {
                  this.ownerID.approved = false;
                }
              }
            },
            onClick () {
                return false;
            },
            getClientInfo () {
                console.log(`Client DOCS, getClientInfo | id -> ${this.clientId}`);
                this.isBusy = true;
                let url = `client/${this.clientId}/verification-documents`;
                this.apiGet(url).then(response => {
                    this.isBusy = false;
                    console.log(response.data);
                    this.verification_documents = response.data.verification_documents || [];
                    this.parseDocuments(this.verification_documents);
                }).catch(error => {
                    this.isBusy = false;
                    this.showErrorNotification(error)
                })
            },
        },
        mounted() {
            this.getClientInfo();
            this.$eventBus.$emit('sidebar-set-active-tab', 'Clients');
        },
        validations: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Clients/ClientDocuments.vue